var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.name,
            expression: "rules.name"
          }
        ],
        attrs: {
          label: "Name",
          name: "Name",
          placeholder: "Valid zone name",
          "error-messages": _vm.errors.collect("Name")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.name,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.ttl,
            expression: "rules.ttl"
          }
        ],
        attrs: {
          label: "TTL",
          name: "TTL",
          placeholder: "14400",
          "error-messages": _vm.errors.collect("TTL")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.ttl,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "ttl", $$v)
          },
          expression: "model.ttl"
        }
      }),
      _c(
        "gg-input-label",
        [
          _vm._v(" Flag "),
          _c(
            "v-tooltip",
            {
              attrs: {
                bottom: "",
                "max-width": "320"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function fn(_ref) {
                    var on = _ref.on
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            staticClass: "pb-1",
                            attrs: {
                              small: ""
                            }
                          },
                          on
                        ),
                        [_vm._v("mdi-information-outline")]
                      )
                    ]
                  }
                }
              ])
            },
            [_c("span", [_vm._v(_vm._s(_vm.tooltip.flag))])]
          )
        ],
        1
      ),
      _c(
        "v-radio-group",
        {
          staticClass: "mt-1",
          attrs: {
            row: "",
            "hide-details": ""
          },
          on: {
            change: _vm.sendData
          },
          model: {
            value: _vm.model.flag,
            callback: function callback($$v) {
              _vm.$set(_vm.model, "flag", $$v)
            },
            expression: "model.flag"
          }
        },
        [
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "0",
              value: "0"
            }
          }),
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "1",
              value: "1"
            }
          })
        ],
        1
      ),
      _c(
        "label",
        {
          staticClass: "mt-1"
        },
        [
          _vm._v(" Tag "),
          _c(
            "v-tooltip",
            {
              attrs: {
                bottom: "",
                "max-width": "320"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function fn(_ref2) {
                    var on = _ref2.on
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            staticClass: "pb-1",
                            attrs: {
                              small: ""
                            }
                          },
                          on
                        ),
                        [_vm._v("mdi-information-outline")]
                      )
                    ]
                  }
                }
              ])
            },
            [_c("span", [_vm._v(_vm._s(_vm.tooltip.tag))])]
          )
        ],
        1
      ),
      _c(
        "v-radio-group",
        {
          staticClass: "mt-1",
          attrs: {
            row: "",
            "hide-details": ""
          },
          on: {
            change: _vm.sendData
          },
          model: {
            value: _vm.model.tag,
            callback: function callback($$v) {
              _vm.$set(_vm.model, "tag", $$v)
            },
            expression: "model.tag"
          }
        },
        [
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "issue",
              value: "issue"
            }
          }),
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "issuewild",
              value: "issuewild"
            }
          }),
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "iodef",
              value: "iodef"
            }
          })
        ],
        1
      ),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.value,
            expression: "rules.value"
          }
        ],
        attrs: {
          label: "Value",
          name: "Value",
          placeholder: "Certificate Authority",
          hint: _vm.tooltip.value,
          "persistent-hint": "",
          "error-messages": _vm.errors.collect("Value")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.value,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "value", $$v)
          },
          expression: "model.value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }